import { COLORS } from '@wehunt/ui'
import { useT } from '../i18n/useT'

export function NotFoundPage() {
  const { t } = useT('common')
  return (
    <div style={{ padding: 48, textAlign: 'center' }}>
      <h1 style={{ color: COLORS.onSurface, fontFamily: COLORS.fontDisplay, margin: 0 }}>404</h1>
      <p style={{ color: COLORS.onSurfaceVariant }}>{t('states.notFound')}</p>
    </div>
  )
}
